
/**
 * This is an utility method to set the values of the ranges of 
 * the RangeSliderComponent src/app/components/shared/range-slider/range-slider.component.ts in the related filter.
 * 
 * The logic is divided in 3 cases:
 * 
 * 1) The ranges are both valued, so they are set in the filter.
 * 2) The max is not valued, so it sets the min and the defaultMax
 * 2) The min is not valued, so it sets the max and the defaultmin
 * @param target - the object where the ranges will be set. Generally its a search filter. 
 * @param keyMin - key of the min
 * @param keyMax - key of the max
 * @param min - the actual min value
 * @param max - the actual max value
 * @param defaultMin - the default min value
 * @param defaultMax - the default max value
 */
export function setRange(
    target: any,
    keyMin: string,
    keyMax: string,
    min: number | null | undefined,
    max: number | null | undefined,
    defaultMin: number,
    defaultMax: number
  ): void {
    const hasMin = min !== null && min !== undefined;
    const hasMax = max !== null && max !== undefined;
  
    // case 1
    if (hasMin && hasMax) {
      target[keyMin] = min;
      target[keyMax] = max;
    } 
    // case 2 
    else if (hasMin && !hasMax) {
        target[keyMin] = min;
        target[keyMax] = defaultMax;
    } 
    // case 3 
    else if (!hasMin && hasMax) {
      target[keyMin] = defaultMin;
      target[keyMax] = max;
    }
  }
  